// TSS vite/03 §"Query keys convention".

export const tokenKeys = {
    all:  ['tokens'],
    list: (params) => ['tokens', 'list', params],
    // The repositories of one project, which is what the issue form offers
    // once a project is chosen.
    repositoriesOf: (projectId) => ['repositories', 'of-project', projectId],
};
